import {Center, Spinner} from 'native-base';

export default function Loading() {
  return (
    <Center position="fixed" w="100%" h="100%"><Spinner size="lg" /></Center>
  );
}